import convertToDomNode from "../../utils/convertToDomNode";
import pipe from "../../lib/core/functional/pipe";
import curry from "../../lib/core/functional/curry";
import objectToDataAttrs from "../../utils/objectToDataAttrs";

const makeClasses = (className, isActive) =>
    ["hover-menu", className, isActive ? "active" : ""].join(" ");

const itemTemplate = ({ className, title, icon, iconClass, dataAttrs, isActive }) =>
    `<span
        class="${makeClasses(className, isActive)}"
        title="${title}"
        ${objectToDataAttrs(dataAttrs)}>
        <i class="${iconClass || "material-icons"}">${icon || ""}</i>
    </span>`;

const itemToDomNode = pipe(itemTemplate, convertToDomNode);

const ACTIVE_SETTERS = {
    freeze(context) {
        return context.isFrozen;
    },
};

const markActive = curry(function markActive(context, item) {
    const isActive = item.name in ACTIVE_SETTERS ? ACTIVE_SETTERS[item.name](context) : false;
    return {
        ...item,
        isActive,
    };
});

function process([context, menuItems]) {
    const itemProccesor = pipe(markActive(context), itemToDomNode);
    function onEachMenuItem(menuItem) {
        return { ...menuItem, html: itemProccesor(menuItem) };
    }
    return [context, menuItems.map(onEachMenuItem)];
}

export default process;
